import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { HabitsSection } from '../components/HabitsSection';
import { ForYouSection } from '../components/ForYouSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0A0A0A] text-white selection:bg-[#22C55E] selection:text-black" data-id="element-152">
      <HeroSection data-id="element-153" />
      <PainPointsSection data-id="element-154" />
      <BenefitsSection data-id="element-155" />
      <HabitsSection data-id="element-156" />
      <ForYouSection data-id="element-157" />
      <FinalCTA data-id="element-158" />
      <Footer data-id="element-159" />
    </main>;
}